import { CalciteButton } from "@esri/calcite-components-react";
import React, { useRef } from "react";
import { ButtonProps } from "./Button.d";

const Button: React.FC<ButtonProps> = ({
  kind = "brand",
  variant = "solid",
  scale = "m",
  width = "auto",
  children,
  isLoading,
  ...remainingProps
}) => {
  const calciteButton = useRef<HTMLCalciteButtonElement>(null);
  return (
    <>
      <CalciteButton
        ref={calciteButton}
        appearance={variant}
        kind={kind}
        scale={scale}
        loading={isLoading}
        width={width}
        {...remainingProps}
      >
        {children}
      </CalciteButton>
    </>
  );
};

export default Button;
